import { ReactComponent as Account } from './Account.svg';
import { ReactComponent as Arrow } from './Arrow.svg';
import { ReactComponent as ArrowLong } from './ArrowLong.svg';
import { ReactComponent as ArrowUpDown } from './ArrowUpDown.svg';
import { ReactComponent as Bell } from './Bell.svg';
import { ReactComponent as Cancel } from './Cancel.svg';
import { ReactComponent as Check } from './Check.svg';
import { ReactComponent as Copy } from './Copy.svg';
import { ReactComponent as Dark } from './Dark.svg';
import { ReactComponent as Dashboard } from './Dashboard.svg';
import { ReactComponent as Disabled } from './Disabled.svg';
import { ReactComponent as DoubleArrow } from './DoubleArrow.svg';
import { ReactComponent as Down } from './Down.svg';
import { ReactComponent as Download } from './Download.svg';
import { ReactComponent as Enabled } from './Enabled.svg';
import { ReactComponent as Error } from './Error.svg';
import { ReactComponent as Exclamation } from './Exclamation.svg';
import { ReactComponent as HashrateMax } from './HashrateMax.svg';
import { ReactComponent as HashrateMin } from './HashrateMin.svg';
import { ReactComponent as Hide } from './Hide.svg';
import { ReactComponent as Light } from './Light.svg';
import { ReactComponent as Logout } from './Logout.svg';
import { ReactComponent as Minus } from './Minus.svg';
import { ReactComponent as Plus } from './Plus.svg';
import { ReactComponent as Power } from './Power.svg';
import { ReactComponent as Refresh } from './Refresh.svg';
import { ReactComponent as Reward } from './Reward.svg';
import { ReactComponent as Search } from './Search.svg';
import { ReactComponent as Setting } from './Setting.svg';
import { ReactComponent as Settings } from './Settings.svg';
import { ReactComponent as Show } from './Show.svg';
import { ReactComponent as Tag } from './Tag.svg';
import { ReactComponent as Wallet } from './Wallet.svg';
import { ReactComponent as Workers } from './Workers.svg';

const iconsIndex = {
  Account,
  Arrow,
  ArrowLong,
  ArrowUpDown,
  Bell,
  Cancel,
  Check,
  Copy,
  Dark,
  Dashboard,
  Disabled,
  DoubleArrow,
  Down,
  Download,
  Enabled,
  Error,
  Exclamation,
  HashrateMax,
  HashrateMin,
  Hide,
  Light,
  Logout,
  Minus,
  Plus,
  Power,
  Refresh,
  Reward,
  Search,
  Setting,
  Settings,
  Show,
  Tag,
  Wallet,
  Workers,
};

export default iconsIndex;